// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vrm {
  font-weight: 500;
  line-height: 1rem !important;
  display: inline-block;
  background-color: var(--vrmBackgroundColour);
  font-size: 0.6rem;
}

.desc {
  line-height: 1rem !important;
}

.search-info {
  font-size: 14px;
  font-weight: 600;
}

.reserve-ball.good {
  background-color: var(--successColour);
  color: #fff;
}
.reserve-ball.bad {
  background-color: #999;
  color: #fff;
}

.action-button {
  color: var(--primaryButtonColour);
  border: 1px solid var(--primaryButtonColour);
  padding: 3px 4px;
  border-radius: 3px;
  white-space: nowrap;
}
.action-button:hover {
  background-color: var(--secondaryButtonColour);
  color: #fff;
}

.saleType {
  width: 110px;
  text-align: center;
  display: inline-block;
  font-weight: 500;
}

.good {
  color: var(--successColour);
}

.get-started {
  font-size: 26px;
  font-weight: 500;
}

.imgcell .img {
  border-radius: 3px;
  width: 50px;
}

.right-pane {
  border-radius: 10px;
  font-size: 0.875rem;
  font-weight: 400;
}
.right-pane ul {
  list-style: none;
  padding: 10px 0px;
  margin: 0px 15px;
}
.right-pane ul li {
  padding-left: 1.3em;
}
.right-pane ul li:before {
  content: "\\f00c"; /* FontAwesome Unicode */
  font-family: var(--fontAwesome);
  font-weight: 900;
  display: inline-block;
  margin-left: -1.3em; /* same as padding-left set on li */
  margin-bottom: 4px;
  margin-top: 5px;
  margin-right: 3px;
  color: var(--successColour);
  width: 1.3em; /* same as padding-left set on li */
}

.bad {
  color: var(--errorColour);
}

mdb-card-header {
  font-weight: 500;
}

.recent-vehicles {
  font-size: 0.9rem;
}
.recent-vehicles td {
  vertical-align: middle;
}
.recent-vehicles .desc {
  max-width: 200px;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/main/dashboard/seller-hub/seller-hub-vehicle-search/seller-hub-vehicle-search.component.scss"],"names":[],"mappings":"AAIA;EACE,gBAAA;EACA,4BAAA;EACA,qBAAA;EACA,4CAAA;EACA,iBAAA;AAHF;;AAMA;EACE,4BAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;AAHF;;AAQE;EACE,sCAAA;EACA,WAAA;AALJ;AAQE;EACE,sBAAA;EACA,WAAA;AANJ;;AAWA;EACE,iCAAA;EACA,4CAAA;EAOA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAdF;AAOE;EACE,8CAAA;EACA,WAAA;AALJ;;AAaA;EAEE,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;AAXF;;AAcA;EAEE,2BAAA;AAZF;;AAgBA;EACE,eAAA;EACA,gBAAA;AAbF;;AAmBE;EACE,kBAAA;EACA,WAAA;AAhBJ;;AAqBA;EAEE,mBAAA;EACA,mBAAA;EACA,gBAAA;AAnBF;AAqBE;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;AAnBJ;AAqBI;EAEE,mBAAA;AApBN;AAsBM;EACE,gBAAA,EAAA,wBAAA;EACA,+BAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA,EAAA,mCAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,YAAA,EAAA,mCAAA;AApBR;;AA0BA;EAEE,yBAAA;AAxBF;;AA4BA;EACE,gBAAA;AAzBF;;AA4BA;EACE,iBAAA;AAzBF;AA2BE;EACE,sBAAA;AAzBJ;AA4BE;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AA1BJ","sourcesContent":[".search-buttons button {\n\n}\n\n.vrm {\n  font-weight: 500;\n  line-height: 1rem !important;\n  display: inline-block;\n  background-color: var(--vrmBackgroundColour);\n  font-size: 0.6rem;\n}\n\n.desc {\n  line-height: 1rem !important;\n}\n\n.search-info {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.reserve-ball {\n\n  &.good {\n    background-color: var(--successColour);\n    color: #fff;\n  }\n\n  &.bad {\n    background-color: #999;\n    color: #fff;\n  }\n\n}\n\n.action-button {\n  color: var(--primaryButtonColour);\n  border: 1px solid var(--primaryButtonColour);\n\n  &:hover {\n    background-color: var(--secondaryButtonColour);\n    color: #fff;\n  }\n\n  padding: 3px 4px;\n  border-radius: 3px;\n  white-space: nowrap;\n}\n\n.saleType {\n\n  width: 110px;\n  text-align: center;\n  display: inline-block;\n  font-weight: 500;\n}\n\n.good {\n\n  color: var(--successColour);\n\n}\n\n.get-started {\n  font-size: 26px;\n  font-weight: 500;\n}\n\n\n.imgcell {\n\n  .img {\n    border-radius: 3px;\n    width: 50px;\n  }\n\n}\n\n.right-pane {\n\n  border-radius: 10px;\n  font-size: 0.875rem;\n  font-weight: 400;\n\n  ul {\n    list-style: none;\n    padding: 10px 00px;\n    margin: 0px 15px;\n\n    li {\n\n      padding-left: 1.3em;\n\n      &:before {\n        content: \"\\f00c\"; /* FontAwesome Unicode */\n        font-family: var(--fontAwesome);\n        font-weight: 900;\n        display: inline-block;\n        margin-left: -1.3em; /* same as padding-left set on li */\n        margin-bottom: 4px;\n        margin-top: 5px;\n        margin-right: 3px;\n        color: var(--successColour);\n        width: 1.3em; /* same as padding-left set on li */\n      }\n    }\n  }\n}\n\n.bad {\n\n  color: var(--errorColour);\n}\n\n\nmdb-card-header {\n  font-weight: 500;\n}\n\n.recent-vehicles {\n  font-size: 0.9rem;\n\n  td {\n    vertical-align: middle;\n  }\n\n  .desc {\n    max-width: 200px;\n    overflow-x: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    font-weight: 500;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
